import React__default from 'react';

var MiniArticleListNewsArticle = function MiniArticleListNewsArticle(props) {
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: "csg-tw- py-2"
  }, props.article.articleLink));
};

export { MiniArticleListNewsArticle };
//# sourceMappingURL=mini-article-list-news-article.esm.js.map
